import { render, staticRenderFns } from "./batteryBunkerOpenRecord.vue?vue&type=template&id=edfd3748&"
import script from "./batteryBunkerOpenRecord.vue?vue&type=script&lang=js&"
export * from "./batteryBunkerOpenRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edfd3748')) {
      api.createRecord('edfd3748', component.options)
    } else {
      api.reload('edfd3748', component.options)
    }
    module.hot.accept("./batteryBunkerOpenRecord.vue?vue&type=template&id=edfd3748&", function () {
      api.rerender('edfd3748', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/iotLog/batteryBunkerOpenRecord/batteryBunkerOpenRecord.vue"
export default component.exports